<template>
  <div class="ui container">
    <h2 class="ui header">
      <i class="settings icon"></i>
      <div class="content">
        {{ $t("robocredit catalogs") }}
        <div class="sub header">{{ $t("catalogs for robocredit") }}</div>
      </div>
    </h2>
    <div class="ui grid">
      <div class="eight wide column">
        <enterprise-name />
      </div>
      <div class="eight wide column">
        <occupation />
      </div>
    </div>
  </div>
</template>

<script>
// import filters from "@/filters";
import EnterpriseName from "./EnterpriseName.vue";
import Occupation from "./Occupation.vue";

export default {
  name: "RobocreditCatalogs",
  components: { EnterpriseName, Occupation },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
